/*
 * SigninPage Messages
 *
 * This contains all the text for the SigninPage container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.SigninPopup';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Đăng nhập',
  },
  subHeader: {
    id: `${scope}.subHeader`,
    defaultMessage: 'Đăng nhập vào tài khoản Kamereo của bạn',
  },
  signup: {
    id: `${scope}.signup`,
    defaultMessage: 'Đăng ký',
  },
  rememberMe: {
    id: `${scope}.rememberMe`,
    defaultMessage: 'Ghi nhớ đăng nhập',
  },
  forgotPassword: {
    id: `${scope}.forgotPassword`,
    defaultMessage: 'Quên mật khẩu?',
  },
  notHasAccountYet: {
    id: `${scope}.notHasAccountYet`,
    defaultMessage: 'Chưa có tài khoản?',
  },
});
